import axios from 'axios';
import Vue from 'vue';

let instance = axios.create();

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');

  if (token != null) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

instance.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    Vue.prototype.$AuthService.logout();
    Vue.toasted.error('Er is een authenticatie fout opgetreden');
  } else {
    if (error.response.status === 400) {
      let msg = error.response.data;
      if (typeof msg === 'string') {
        Vue.toasted.error(msg);
      } else if (typeof msg === 'object') {
        if (msg.hasOwnProperty('Model')) {
          msg['Model'].forEach(e => {
            Vue.toasted.error(e);
          });
        } else {
          Vue.toasted.error('Er is iets fout gegaan met uw verzoek.');
        }
      }
    }
  }
  return Promise.reject(error);
});

export const api = instance;
